export const reportCatalog = [
  {
    id: 'rep_dre',
    category: 'Financeiro',
    title: 'DRE gerencial',
    description: 'Demonstrativo de resultado do exercício com visão gerencial.',
  },
  {
    id: 'rep_fluxo',
    category: 'Financeiro',
    title: 'Fluxo de caixa',
    description: 'Entradas, saídas e saldo projetado do período.',
  },
  {
    id: 'rep_pagar',
    category: 'Financeiro',
    title: 'Contas a pagar',
    description: 'Obrigações por status, vencimento e fornecedor.',
  },
  {
    id: 'rep_receber',
    category: 'Financeiro',
    title: 'Contas a receber',
    description: 'Recebíveis previstos, recebidos e em atraso.',
  },
  {
    id: 'rep_resultado',
    category: 'Financeiro',
    title: 'Resultado mensal',
    description: 'Comparativo de resultado mês a mês.',
  },
  {
    id: 'rep_fat_cliente',
    category: 'Clientes',
    title: 'Faturamento por cliente',
    description: 'Ranking de faturamento e participação.',
  },
  {
    id: 'rep_inad',
    category: 'Clientes',
    title: 'Clientes inadimplentes',
    description: 'Lista de clientes com títulos em atraso.',
  },
  {
    id: 'rep_gastos_forn',
    category: 'Fornecedores',
    title: 'Gastos por fornecedor',
    description: 'Concentração de despesas por fornecedor.',
  },
  {
    id: 'rep_notas',
    category: 'Fiscal',
    title: 'Notas emitidas',
    description: 'NFS-e emitidas no período com status.',
  },
  {
    id: 'rep_fat_fiscal',
    category: 'Fiscal',
    title: 'Faturamento',
    description: 'Faturamento fiscal consolidado.',
  },
];

export const dreData = {
  period: 'Setembro/2026',
  lines: [
    { label: 'Receita bruta', amount: 80000, type: 'positive' },
    { label: '(-) Impostos', amount: 8000, type: 'negative' },
    { label: 'Receita líquida', amount: 72000, type: 'subtotal' },
    { label: '(-) Custos', amount: 25000, type: 'negative' },
    { label: 'Margem bruta', amount: 47000, type: 'subtotal' },
    { label: '(-) Despesas operacionais', amount: 20000, type: 'negative' },
    { label: 'Resultado operacional', amount: 27000, type: 'total' },
  ],
  evolution: [
    { month: 'Abr', resultado: 13500 },
    { month: 'Mai', resultado: 7300 },
    { month: 'Jun', resultado: 15300 },
    { month: 'Jul', resultado: 16100 },
    { month: 'Ago', resultado: 15300 },
    { month: 'Set', resultado: 12580 },
  ],
};
